import { ContactForm, Modal } from "../..";
import { MessageModel } from "../../../../service";
import { toast } from "react-toastify";
import { toastError } from "../../../../utils/toastSafe";
import { FiMail, FiPhone } from "react-icons/fi";
import { telHrefFromDisplay } from "../../../../constants/contact";
// import { Row } from 'react-bootstrap/Row';

type modalProps = {
  title: string;
  open: boolean;
  toggleModal: () => void;
  data: {
    _id: string;
    name: string;
    email: string;
    designation: string;
    phone: string;
    officePhone?: string;
    license: string;
    image: string;
    description?: string;
  };
};

type formValues = {
  name: string;
  email: string;
  subject: string;
  message: string;
};

const TeamMemberModal = (props: modalProps) => {
  const onFormSubmit = async (values: formValues) => {
    try {
      const body = {
        ...values,
        subject:
          values.subject?.trim() ||
          `Team inquiry: ${props.data.name} (${props.data.designation})`,
        message: `[Regarding: ${props.data.name} — ${props.data.designation}]\n\n${values.message}`,
      };
      const response = await MessageModel.registerMessage(body);
      if (response.status === 200) {
        toast.success("Message sent!");
        props.toggleModal();
      }
    } catch (error) {
      console.log(error);
      toastError("Something went wrong!");
    }
  };
  return (
    <Modal title="Profile" open={props.open} toggleModal={props.toggleModal}>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 p-2">
        <div>
          {" "}
          <img
            className="mb-4"
            src={
              props.data.image === "avatar.jpg"
                ? "/images/avatar.png"
                : props.data.image
            }
            alt={props.data.name}
          />
          <h3 className="text-md text-center font-semibold mb-0">
            {props.data.name}
          </h3>
          <p className="text-gray-600 text-center text-sm mb-2">
            <span className="font-semibold"></span> {props.data.designation}
          </p>
        </div>
        <div className="col-span-2 px-4 sm:px-6 md:px-8">
          {props.data.description !== "NA" &&
            props.data.description?.split("\\n").map((line, i) => (
              <p
                key={i}
                className="text-gray-600 text-sm text-justify leading-5 font-medium my-6"
              >
                {line}
              </p>
            ))}
        </div>
      </div>

      <div className="mt-6 flex flex-col gap-4 px-4">
        <p className="text-gray-600 text-sm text-center">
          <span className="font-semibold">License#:</span> {props.data.license}
        </p>
        <a
          href={`mailto:${props.data.email}`}
          className="inline-flex items-center justify-center gap-2 text-sm text-gray-600 hover:text-cred-100 transition-colors"
        >
          <FiMail className="text-cred-100 shrink-0" size={18} aria-hidden />
          <span>{props.data.email}</span>
        </a>
        <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4">
          <div className="text-center">
            <span className="block text-xs text-gray-500 mb-1">Mobile</span>
            <a
              href={telHrefFromDisplay(props.data.phone)}
              className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-cred-100 transition-colors"
            >
              <FiPhone className="text-cred-100 shrink-0" size={18} aria-hidden />
              <span>{props.data.phone}</span>
            </a>
          </div>
          {props.data.officePhone ? (
            <div className="text-center">
              <span className="block text-xs text-gray-500 mb-1">Office</span>
              <a
                href={telHrefFromDisplay(props.data.officePhone)}
                className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-cred-100 transition-colors"
              >
                <FiPhone className="text-cred-100 shrink-0" size={18} aria-hidden />
                <span>{props.data.officePhone}</span>
              </a>
            </div>
          ) : null}
        </div>
      </div>

      <hr className="border-t my-4 w-full border-red-500 border-b-2" />

      <div className="border-0 mt-8">
        <h3 className="text-lg font-semibold text-center mb-2">
          Send Me a Message
        </h3>
        <div className="px-5">
          <ContactForm onFormSubmit={onFormSubmit} />
        </div>
      </div>
    </Modal>
  );
};

export default TeamMemberModal;
